import PopupContent from './PopupContent';
import PopupSideBar from './PopupSideBar';

const PopupStyles = {
  PopupContent,
  PopupSideBar,
};

export default PopupStyles;
